import CreateShopScreen from '../../src/screens/CreateShopScreen';

export default function CreateShopRoute() {
  return <CreateShopScreen />;
}
